const SOURCE_INCOME_TEXT = {
  ACCOUNT_HANDLER: 'Who will operate this account?',
  ACCOUNT_HANDLER_DESCRIPTION:
    'For security and compliance, please confirm who will be operating this account.',
  PERSONAL_OPERATOR: 'I will personally operate this account.',
  OTHER_OPERATOR: 'Someone else will operate for me.',
  SOURCE_INCOME: 'What is your primary source of income?',
  SOURCE_INCOME_DESCRIPTION:
    'Since you are retired, please let us know how you fund your account.',
  CONFIRM: 'Confirm',
  NEXT: 'Next',
  CONFIRM_AND_SUBMIT: 'Confirm & Submit',
  CONTINUE: 'Continue',
  INCOME_HANDLER_DESCRIPTION: (occupation: string) =>
    `Since you are a ${occupation}, please let us know how you fund your account.`,
  INCOME_HANDLER_OTHER_DESCRIPTION:
    'Please help us understand how you fund your account.',
  STATUS_MODAL_TITLE_SUCCESS: 'Your details have been saved successfully',
  STATUS_MODAL_TITLE_ERROR: 'Failed to save your details.',
};

const OTHER_INCOME_TERMS = {
  HEADING: 'This authorisation includes the right to:',
  POINT_1: 'Execute and confirm transactions',
  POINT_2: 'Access account-related information and',
  POINT_3:
    'Perform all other acts necessary or incidental to the smoothly operation of my account, as permitted under applicable laws and firm policies',
  DESC_1:
    'This authorisation is granted with full trust and confidence and shall remain valid until I provide written notice of revocation to Delta Exchange. I confirm that I understand the risks associated with trading and that I take full responsibility for any decisions or actions taken by my authorised representative on my behalf.',
  AGGREMENT_TEXT: 'I confirm the above individual is authorised.',
};

const SOURCE_INCOME_RETIRED = [
  {
    label: 'Pension',
    value: 'pension',
  },
  {
    label: 'Family Support / Allowance',
    value: 'family_support_or_allowance',
  },
  {
    label: 'Rental Income',
    value: 'rental_income',
  },
  {
    label: 'Interest / Dividends',
    value: 'interest_or_dividends',
  },
  {
    label: 'Savings',
    value: 'savings',
  },
  {
    label: 'Investments / Maturity Proceeds',
    value: 'investments_or_maturity_proceeds',
  },
  {
    label: 'Agricultural Income',
    value: 'agricultural_income',
  },
  {
    label: 'Business Income / Profits',
    value: 'business_income_or_profits',
  },
  {
    label: 'Gift / Inheritance',
    value: 'gift_or_inheritance',
  },
  {
    label: 'Other',
    value: 'other',
  },
];

const SOURCE_INCOME_HOUSEWIFE = [
  {
    label: 'Family Support / Allowance',
    value: 'family_support_or_allowance',
  },
  {
    label: 'Rental Income',
    value: 'rental_income',
  },
  {
    label: 'Interest / Dividends',
    value: 'interest_or_dividends',
  },
  {
    label: 'Savings',
    value: 'savings',
  },
  {
    label: 'Investments / Maturity Proceeds',
    value: 'investments_or_maturity_proceeds',
  },
  {
    label: 'Agricultural Income',
    value: 'agricultural_income',
  },
  {
    label: 'Business Income / Profits',
    value: 'business_income_or_profits',
  },
  {
    label: 'Spouse Support',
    value: 'spouse_support',
  },
  {
    label: 'Gift / Inheritance',
    value: 'gift_or_inheritance',
  },
  {
    label: 'Other',
    value: 'other',
  },
];

const SOURCE_INCOME_STUDENT = [
  {
    label: 'Family Support / Allowance',
    value: 'family_support_or_allowance',
  },
  {
    label: 'Scholarship / Stipend',
    value: 'scholarship_or_stipend',
  },
  {
    label: 'Part-time Job Income',
    value: 'part_time_job_income',
  },
  {
    label: 'Investments / Savings',
    value: 'investments_or_savings', // mssing in API opayload
  },
  {
    label: 'Gift / Inheritance',
    value: 'gift_or_inheritance',
  },
  {
    label: 'Other',
    value: 'other',
  },
];

const SOURCE_INCOME_BUSINESS = [
  {
    label: 'Business Income / Profits',
    value: 'business_income_or_profits',
  },
  {
    label: 'Investments / Dividends',
    value: 'investments_or_dividends',
  },
  {
    label: 'Agricultural Income',
    value: 'agricultural_income',
  },
  {
    label: 'Rental Income',
    value: 'rental_income',
  },
  {
    label: 'Gift / Inheritance',
    value: 'gift_or_inheritance',
  },
  {
    label: 'Other',
    value: 'other',
  },
];

const SOURCE_INCOME_OTHERS = [
  {
    label: 'Freelancing / Contract Work',
    value: 'freelancing_or_contract_work',
  },
  {
    label: 'Family Support / Allowance',
    value: 'family_support_or_allowance',
  },
  {
    label: 'Investments / Savings',
    value: 'investments_or_savings',
  },
  {
    label: 'Gift / Inheritance',
    value: 'gift_or_inheritance',
  },
  {
    label: 'Other',
    value: 'other',
  },
];

const SOURCE_INCOME_NOT_WORKING = [
  {
    label: 'Pension / Retirement Fund',
    value: 'pension_or_retirement_fund',
  },
  {
    label: 'Rental Income',
    value: 'rental_income',
  },
  {
    label: 'Family Support / Allowance',
    value: 'family_support_or_allowance',
  },
  {
    label: 'Investments / Savings',
    value: 'investments_or_savings',
  },
  {
    label: 'Gift / Inheritance',
    value: 'gift_or_inheritance',
  },
  {
    label: 'Other',
    value: 'other',
  },
];

const AUTHORISED_PERSON_RELATIONSHIP = [
  {
    label: 'Spouse',
    value: 'spouse',
  },
  {
    label: 'Parent',
    value: 'parent',
  },
  {
    label: 'Child',
    value: 'child',
  },
  {
    label: 'Business Partner',
    value: 'businessPartner',
  },
  {
    label: 'Other',
    value: 'other',
  },
];

const SOURCE_INCOME_OPERATOR = {
  PERSONAL_OPERATOR: 'self',
  OTHER_OPERATOR: 'other',
};

enum STEPS {
  ACCOUNT_HANDLER = 'accountHandler',
  INCOME_HANDLER = 'incomeHandler',
  OTHER_INCOME_HANDLER = 'otherIncomeHandler',
  SUCCESS = 'SUCCESS_MODAL',
  ERROR = 'ERROR_MODAL',
}

const OCCUPATION = {
  RETIRED: 'Retired',
  HOUSEWIFE: 'Housewife',
  STUDENT: 'Student',
  BUSINESS: 'Business',
  OTHER: 'Others',
  NOT_WORKING: 'Not Working',
};

const MAP_INCOME_TO_OCCUPATION = {
  [OCCUPATION.RETIRED]: SOURCE_INCOME_RETIRED,
  [OCCUPATION.HOUSEWIFE]: SOURCE_INCOME_HOUSEWIFE,
  [OCCUPATION.STUDENT]: SOURCE_INCOME_STUDENT,
  [OCCUPATION.BUSINESS]: SOURCE_INCOME_BUSINESS,
  [OCCUPATION.OTHER]: SOURCE_INCOME_OTHERS,
  [OCCUPATION.NOT_WORKING]: SOURCE_INCOME_NOT_WORKING,
};

const TITLE_MAP: Record<string, string> = {
  [STEPS.ACCOUNT_HANDLER]: SOURCE_INCOME_TEXT.ACCOUNT_HANDLER,
  [STEPS.OTHER_INCOME_HANDLER]: SOURCE_INCOME_TEXT.ACCOUNT_HANDLER,
  [STEPS.INCOME_HANDLER]: SOURCE_INCOME_TEXT.SOURCE_INCOME,
};

export {
  SOURCE_INCOME_TEXT,
  SOURCE_INCOME_OPERATOR,
  SOURCE_INCOME_RETIRED,
  SOURCE_INCOME_HOUSEWIFE,
  SOURCE_INCOME_STUDENT,
  SOURCE_INCOME_BUSINESS,
  SOURCE_INCOME_OTHERS,
  SOURCE_INCOME_NOT_WORKING,
  OTHER_INCOME_TERMS,
  AUTHORISED_PERSON_RELATIONSHIP,
  OCCUPATION,
  STEPS,
  MAP_INCOME_TO_OCCUPATION,
  TITLE_MAP,
};
